<div class="profile-picture-container">
    <img [src]="src" alt="Profile Picture" class="profile-picture" />
    <label class="upload-btn">
        <input type="file" (change)="onFileSelected($event)" accept="image/*" />
        {{label}}
    </label>
</div>